import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { Ellipse, ElementEventClick, Stroke } from '../../types';

@Component({
  selector: 'g[svg-ellipse]',
  templateUrl: './svgellipse.component.html',
  styleUrls: ['./svgellipse.component.css']
})
export class SvgEllipseComponent implements OnInit {


  constructor() { }


  @Input()
  public ellipse: Ellipse;

  @Output()
  public ellipseMousedown = new EventEmitter<{ mouseEvent: MouseEvent, ellipse: Ellipse }>();
  @Output()
  public ellipseMouseover = new EventEmitter<{ mouseEvent: MouseEvent, ellipse: Ellipse }>();

  ngOnInit() {

    if (!this.ellipse.stroke) {
      this.ellipse.stroke = new Stroke();
    }
  }

  public onEllipseMouseDown($event) {
    if ($event) {
      this.ellipseMousedown.emit({ mouseEvent: $event, ellipse: this.ellipse });
    }

  }
  
  public onEllipseMouseOver($event) {
    if ($event) {
      this.ellipseMouseover.emit({ mouseEvent: $event, ellipse: this.ellipse });
    }

  }
}
